//LOGIN
export const SET_DATOS_USUARIO = "SET_DATOS_USUARIO"
export const GET_USUARIO = "GET_USUARIO";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_TOKEN = "UPDATE_TOKEN"
export const UPDATE_ESTADO_CARGANDO = "UPDATE_ESTADO_CARGANDO";
export const UPDATE_TIEMPO_SESION = "UPDATE_TIEMPO_SESION";
export const UPDATE_ERROR = "UPDATE_ERROR";

//PAGO
export const SET_TIPO_MERCADO = "SET_TIPO_MERCADO";
export const SET_MENSAJE_ERROR = "SET_MENSAJE_ERROR";
export const SET_DATA_VISA = "SET_DATA_VISA";
export const SET_DATA_SAFETYPAY = "SET_DATA_SAFETYPAY";
export const SET_DATA_PAGOLINK = "SET_DATA_PAGOLINK";
export const ADD_PAGO_CONTADOR = "ADD_PAGO_CONTADOR";
//DATOS GENERALES
export const GET_LISTA_PROSPECTOS = "GET_LISTA_PROSPECTOS";
export const ADD_PROSPECTO = 'ADD_PROSPECTO';
export const SET_LISTA_PROSPECTOS = "SET_LISTA_PROSPECTOS";
export const SET_DATA_PROSPECTO = "SET_DATA_PROSPECTO";
export const FINALIZAR_PROSPECTO = "FINALIZAR_PROSPECTO";
export const UPDATE_DATA_PROSPECTO = "UPDATE_DATA_PROSPECTO";
export const CONTINUAR_PROCESO = "CONTINUAR_PROCESO";
export const LIMPIAR_DATA_PROCESO = "LIMPIAR_DATA_PROCESO"  //variable para limpiar pintado del submenu
export const GET_LISTA_MENU = "GET_LISTA_MENU";
export const GET_LISTA_SUB_MENU = "GET_LISTA_SUB_MENU";
export const DELETE_OPCION_MENU = "DELETE_OPCION_MENU";
export const SET_SOLICITUD_PROSPECTO = "SET_SOLICITUD_PROSPECTO";
export const SET_ASEGURADO_PROSPECTO = "SET_ASEGURADO_PROSPECTO";
export const UPDATE_LPDP_PROSPECTO = "UPDATE_LPDP_PROSPECTO";
export const UPDATE_ASEGURADO_PROSPECTO = "UPDATE_ASEGURADO_PROSPECTO";
export const UPDATE_ASEGURADO_ADICIONAL_PROSPECTO = "UPDATE_ASEGURADO_ADICIONAL_PROSPECTO";
export const UPDATE_ESTADO_PROSPECTO = "UPDATE_ESTADO_PROSPECTO"
export const UPDATE_ESTADO_FIRMA = "UPDATE_ESTADO_FIRMA"
export const REFLEX_DATA_RESPONSE_FIRMA = "REFLEX_DATA_RESPONSE_FIRMA";
export const SET_REQUISITOS_INICIALES = "SET_REQUISITOS_INICIALES"
export const UPDATE_CORREO_CONTRATANTE = "UPDATE_CORREO_CONTRATANTE"
export const UPDATE_CORREO_ASEGURADO = "UPDATE_CORREO_ASEGURADO"
export const UPDATE_REEMPLAZO_FIELD = "UPDATE_ASEGURADO_FIELD";
export const UPDATE_REEMPLAZO_FIELD_ADICIONAL = "UPDATE_ASEGURADO_FIELD_ADICIONAL";
export const CLEAN_ASEGURADO_FIELD = "CLEAN_ASEGURADO_FIELD";
export const CLEAN_ASEGURADO_FIELD_ADICIONAL = "CLEAN_ASEGURADO_FIELD_ADICIONAL";
export const DELETE_DETALLE_REEMPLAZO = "DELETE_DETALLE_REEMPLAZO"
export const DELETE_DETALLE_REEMPLAZO_ADICIONAL = "DELETE_DETALLE_REEMPLAZO_ADICIONAL"
export const UPDATE_RESPUESTA_RAPIDA = "UPDATE_RESPUESTA_RAPIDA"
export const SET_ASEGURADO_ADICIONAL_PROSPECTO = "SET_ASEGURADO_ADICIONAL_PROSPECTO";

//IMAGEN
export const UPDATE_INFORMATION_PHOTO = "UPDATE_INFORMATION_PHOTO";
export const UPDATE_INFORMATION_PHOTO_ADICIONAL = "UPDATE_INFORMATION_PHOTO_ADICIONAL";

//NUEVO PROCESO
export const SET_COTIZACIONES = "SET_COTIZACIONES";
export const SET_DATOS_INICIALES_COTIZACION = "SET_DATOS_INICIALES_COTIZACION";
export const SET_CONTRATANTE_COTIZACION = "SET_CONTRATANTE_COTIZACION";

//TABLAS MAESTRAS
export const SET_TABLAS_MAESTRAS = "SET_TABLAS_MAESTRAS"
export const AGREGAR_TABLA_MAESTRA = "AGREGAR_TABLA_MAESTRA"
export const SET_PARAMETROS = "SET_PARAMETROS"

// BENEFICIOS
export const SET_BENEFICIOS = "BENEFICIOS"

// EXCLUSIONES
export const SET_EXCLUSIONES = "EXCLUSIONES"

// SEMAFORO
export const SET_PAGO_RECURRENTE = "SET_PAGO_RECURRENTE"
export const SET_BENEFICIARIOS = "SET_BENEFICIARIOS"
export const SET_CODIGO_AGENCIA = "SET_CODIGO_AGENCIA"

export const UPDATE_SOLICITUD = "UPDATE_SOLICITUD"